"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cookie = _interopRequireDefault(require("cookie"));
var safeParse = function safeParse(object) {
  var parsedObject;
  try {
    parsedObject = JSON.parse(object);
  } catch (e) {
    parsedObject = object;
  }
  return parsedObject;
};
var deepFind = function deepFind(object, targetKey) {
  var parsedObject = safeParse(object);
  var keys = Object.keys(parsedObject);
  if (parsedObject[targetKey]) return safeParse(parsedObject[targetKey]);
  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var nestedObject = safeParse(parsedObject[key]);
    if (nestedObject && nestedObject.constructor.name === 'Object') {
      var value = deepFind(nestedObject, targetKey);
      if (value) return value;
    }
  }
  return null;
};
var getShopperId = function getShopperId() {
  var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.cookie;
  var targetKey = 'info_shopperId';
  var parsedCookie = _cookie.default.parse(cookie);
  return deepFind(parsedCookie, targetKey);
};
var _default = exports.default = getShopperId;